import { render } from "./Settings.vue?vue&type=template&id=33fcbd3e&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./custom-settings.scss?vue&type=style&index=0&id=33fcbd3e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33fcbd3e"]])

export default __exports__